var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcPresencial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.89 43.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke:#7ab5e5;}.cls-2{stroke:#314e9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.13,
    y: 26.81,
    width: 1.73,
    height: 1.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.13,
    y: 13.66,
    width: 1.73,
    height: 13.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.67,
    y: 26.81,
    width: 1.72,
    height: 1.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.67,
    y: 13.66,
    width: 1.72,
    height: 13.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.86 24.64 22.86 26.41 22.86 26.99 22.86 39.16 25.43 39.16 27.18 26.99 27.35 26.99 29.09 39.16 31.67 39.16 31.67 26.99 31.67 26.41 31.67 24.64 22.86 24.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.67 24.64 22.86 24.64 25.04 21.12 22.86 13.66 25.4 13.66 29.12 13.66 31.67 13.66 29.68 21.12 31.67 24.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.77,13.66V8.58a3.49,3.49,0,1,1,7,0v5.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "25.39 13.66 25.39 8.2 29.14 8.2 29.14 13.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.26,
    y1: 10.21,
    x2: 27.26,
    y2: 11.31
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "12.58 11.67 13.26 15.41 12.38 15.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.41,
    y: 30.42,
    width: 2.19,
    height: 1.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "20.14 32.12 20.14 33.86 17.95 33.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "10.59 18.02 10.59 11.67 14.96 11.67 14.96 18.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.95 32.21 17.95 42.58 14.92 42.58 12.77 32.12 10.62 42.58 7.59 42.58 7.59 32.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.95 18.03 20.14 18.03 20.14 32.12 17.95 32.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "7.59 18.03 0.5 25.12 5.41 30.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.59,
    y: 18.03,
    width: 10.36,
    height: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.82.5H15.49a3,3,0,0,0,0,5.92h.12v4.39l3.58-4.39h2.63a3,3,0,1,0,0-5.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcPresencial);
export default __webpack_public_path__ + "static/media/ac-presencial.c98eff406da0fcdfd33cad77b2c3d461.svg";
export { ForwardRef as ReactComponent };